import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";

function PitchResult({ gid, setHidden }) {
  const match = gid.match(/gid:\/\/qwoted\/([^/]+)\/(\d+)/);
  const pitchId = match ? match[2] : null;
  const [pitch, setPitch] = useState(null);
  const [pitchedEntity, setPitchedEntity] = useState(null);
  const [request, setRequest] = useState(null);

  useEffect(() => {
    const query = `${globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL}/rest/v1/pitches?id=eq.${pitchId}`;
    fetch(query, {
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson[0]) {
          const p = responseJson[0];
          setPitch(p);
          setPitchedEntity(p.pitched_entities && p.pitched_entities[0]);
          // setResultTitle(p.profile_name);
          // setResultUrl(`/profiles/${p.profile_slug}`);
        }
      });
  }, [pitchId]);

  useEffect(() => {
    if (!pitch?.request_id) return;
    const query = `${globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL}/rest/v1/requests?id=eq.${pitch.request_id}`;
    fetch(query, {
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson[0]) {
          const r = responseJson[0];
          setRequest(r);
        }
      });
  }, [pitch]);

  useEffect(() => {
    if (!pitch || !pitchedEntity) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  }, [pitch, pitchedEntity, setHidden]);

  if (!pitch || !pitchedEntity) return null;

  return (
    <>
      <a href={`/profiles/${pitch.profile_slug}`}>{pitch.profile_name}</a> pitched:
      <a href={`/my_requests/${pitch.request_slug}`} className="d-flex mt-2">
        <ImageCropped wrapperClasses="me-2" src={pitchedEntity.image_url} alt={pitchedEntity.name} size={45} />
        <div className="d-flex flex-column lh-sm">
          <div className="fs-3">{pitchedEntity.name}</div>
          <div className="text-secondary">
            {pitchedEntity.title}
            <br />
            {pitchedEntity.company_name}
          </div>
        </div>
      </a>
      <span className="badge rounded-pill text-bg-secondary">Pitch</span>{" "}
      {request?.migrate_id && <a href={`${globalThis.Qwoted.V1_URL}/source_requests/${request.migrate_id}`}>V1 Link</a>}
    </>
  );
}

PitchResult.propTypes = {
  gid: PropTypes.string.isRequired,
  setHidden: PropTypes.func.isRequired,
};

export default PitchResult;
